<template>
    <div class="form_item">
        <p class="form_item_title">Область</p>
        <div class="fullWidth text-left">
            <div>
                <button class=" dropdown-toggle dropDownStyle  w-100 styledBtn" data-toggle="dropdown" aria-expanded="true">
                    <span v-if="selectedRegion == null" class="gray">Виберіть</span>
                    <span v-else>{{ getRegionName(selectedRegion) }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-scale dDMStyle styledDW">
                    <span v-for="region in sortedRegions" class="dropdown-item" @click="selectRegion(region)">{{ getRegionName(region) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RegionSelectComponent",

    props: {
        lang: String,
        regions: Array,
    },

    data: function () {
        return {
            selectedRegion: null,
        }
    },

    computed: {
        sortedRegions: function () {
            function compare(a, b) {
                return a.ua.localeCompare(b.ua);
            }

            return this.regions.sort(compare);
        }
    },

    methods: {
        selectRegion(region) {
            this.selectedRegion = region;
            this.$emit('region-selected', region.id, region.center);
        },

        getRegionName(region) {
            return this.lang === 'en' ? region.en : region.ua;
        }
    }
}
</script>

<style scoped>

</style>
